import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f989a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container page-category" }
const _hoisted_2 = { class: "search-wrapper" }
const _hoisted_3 = { class: "box-filter" }
const _hoisted_4 = { class: "product-wrapper" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 0,
  class: "pagination-wrapper"
}

import { ref, reactive, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { BreadcrumbRoute } from '@/types/breadcrumb-route';
  import { useI18n } from 'vue-i18n';
  import { request } from '@/utils';
  import { Collection, TaxonListStore } from '@/stores';
  import _ from 'lodash';

  interface IProps {
    taxonListStore: TaxonListStore;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    taxonListStore: null
  },
  setup(__props: any) {

  
  const { t } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const store = Collection.create<Collection>({
    params: {
      per_page: 6,
      taxons_id_eq: route.query?.taxon_id || undefined,
      is_master_eq: true,
      price_between: route.query?.price_between || undefined,
      keyword: route.query?.keyword || undefined,
    },
    fetch(params = {}) {
      return request.get('/bean/variants', { params });
    }
  });
  const routes = reactive<BreadcrumbRoute[]>([
    { name: t('Home'), to: { name: 'home' } },
    { name: t('Shop'), to: { name: 'shop.index' } },
    { name: 'Title' }
  ]);
  const keyword = ref(String(route.query.keyword || ''));

  const priceOptions = [
    { text: 'Cost', value: '' },
    { text: 'Under $50', value: '0-50' },
    { text: '$51-$100', value: '51-100' },
    { text: '$101-$150', value: '101-150' },
    { text: 'Over $150', value: '151' },
  ];

  function handleTaxonChange(val: number | string) {
    router.replace({ query: { ...route.query, taxon_id: val, page: 1 } });
  }

  function handleOrderChange(val: string) {
    router.replace({ query: { ...route.query, price_between: val, page: 1 } });
  }

  function handleSearch() {
    router.replace({ query: { ...route.query, keyword: keyword.value, page: 1 } });
  }

  function handlePagination(page: any) {
    router.replace({ query: { ...route.query, page } });
  }

  onMounted(() => {
    store.fetchData({ ...store.params, ..._.pick(route.query, ['page', 'keyword']) });
  });


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppCardVariant = _resolveComponent("AppCardVariant")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, { routes: _unref(routes) }, null, 8, ["routes"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppSearch, {
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        modelModifiers: { trim: true },
        placeholder: "What do you want to recycle？",
        onSearch: handleSearch
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_b_form_select, {
        options: __props.taxonListStore.selectOptions,
        "model-value": _unref(store).params.taxons_id_eq,
        "onUpdate:modelValue": handleTaxonChange
      }, null, 8, ["options", "model-value"]),
      _createVNode(_component_b_form_select, {
        options: priceOptions,
        "model-value": _unref(store).params.price_between,
        "onUpdate:modelValue": handleOrderChange
      }, null, 8, ["model-value"])
    ]),
    (_unref(store).isEmpty)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, {
          key: 0,
          text: keyword.value ? _unref(t)('No search results') : undefined,
          mode: keyword.value ? 'search' : 'data'
        }, null, 8, ["text", "mode"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-12 col-md-4"
                }, [
                  _createVNode(_component_AppCardVariant, {
                    modelValue: _unref(store).data[index],
                    "onUpdate:modelValue": ($event: any) => ((_unref(store).data[index]) = $event),
                    class: "product-item"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ]),
          (_unref(store).isFulfilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_AppPagination, {
                  total: _unref(store).meta.total,
                  "per-page": _unref(store).meta.per_page,
                  page: _unref(store).meta.page,
                  onChange: handlePagination
                }, null, 8, ["total", "per-page", "page"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})